import { createContext } from 'preact'
import { useContext, useState } from 'preact/hooks'

interface PageLoaderContextType {
  isLoading: boolean
  showPageLoader: () => void
  hidePageLoader: () => void
}

const PageLoaderContext = createContext<PageLoaderContextType | undefined>(
  undefined
)

interface PageLoaderProviderProps {
  children: preact.ComponentChildren
}

export function PageLoaderProvider({ children }: PageLoaderProviderProps) {
  const [isLoading, setIsLoading] = useState(false)

  const showPageLoader = () => setIsLoading(true)
  const hidePageLoader = () => setIsLoading(false)

  return (
    <PageLoaderContext.Provider
      value={{ isLoading, showPageLoader, hidePageLoader }}
    >
      {children}
      {isLoading && (
        <div className='fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center'>
          <div className='w-24 h-24 border-8 border-cencert-border-gray border-t-cencert-blue rounded-full animate-spin'></div>
        </div>
      )}
    </PageLoaderContext.Provider>
  )
}

export function usePageLoader() {
  const context = useContext(PageLoaderContext)
  if (context === undefined) {
    throw new Error('usePageLoader must be used within a PageLoaderProvider')
  }
  return context
}
